import { Spin } from 'antd';

import LoadingBar from './ProcessBar';

interface LoadingProps {
  Bar: typeof LoadingBar;
}

const Loading: React.FC<Parameters<typeof Spin>[0]> & LoadingProps = (props) => {
  return <Spin {...props} />;
};

Loading.Bar = LoadingBar;

export default Loading;
